import { __awaiter, __generator } from "tslib";
import { queryCache } from '@office-start/data-fetching';
import { setGlobalItem } from '@office-start/web-storage-utility';
import { searchCenterUrlKey } from './constants';
function fetchSearchCenterUrlFromBackendQuery(fetchSearchCenterUrl, options) {
    var sharePointResourceId = options.sharePointResourceId, sharePointTokenProvider = options.sharePointTokenProvider;
    return queryCache.fetchQuery('SearchCenterUrl', function () {
        return fetchSearchCenterUrl({
            siteRoot: sharePointResourceId,
            tokenProvider: sharePointTokenProvider,
        }).catch(function () { return "".concat(sharePointResourceId); });
    }, {});
}
export function fetchSearchCenterUrlFromBackendInternal(fetchSearchCenterUrl, options) {
    return __awaiter(this, void 0, void 0, function () {
        var searchCenterUrlFromBackend;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchSearchCenterUrlFromBackendQuery(fetchSearchCenterUrl, options)];
                case 1:
                    searchCenterUrlFromBackend = _a.sent();
                    // save the search center url in local storage
                    setGlobalItem(searchCenterUrlKey, searchCenterUrlFromBackend);
                    return [2 /*return*/, searchCenterUrlFromBackend];
            }
        });
    });
}
//# sourceMappingURL=fetchSearchCenterUrlFromBackend.js.map